import { FocusSDK, getWebEnvObj, isFocusEnv } from "@/utils";

export enum ClientConfigEnum {
  JD_AUDIO = "jdAudio"
}

export interface ClientConfig {
  // [ConfigEnum.LEFT_SIDER_ENABLE]: boolean;
  // // 会话相关
  // [ChatConfig.CHAT_SESSION_CREATE_GROUP_ENABLE]: boolean;
  // [ChatConfig.CHAT_SESSION_LIST_ENABLE]: boolean;
  // [ChatConfig.CHAT_SESSION_LIST_GROUP_ENABLE]: boolean;
  // [ChatConfig.CHAT_SESSION_LIST_GROUP_ALL_ENABLE]: boolean;
  // [ChatConfig.CHAT_SESSION_LIST_GROUP_TIME_ENABLE]: boolean;
  // [ChatConfig.CHAT_SESSION_LIST_GROUP_TYPE_ENABLE]: boolean;
  // [ChatConfig.CHAT_SESSION_LIST_GROUP_UNREAD_ENABLE]: boolean;
  // [ChatConfig.CHAT_SESSION_LIST_GROUP_IMPORTANT_ENABLE]: boolean;
  // [ChatConfig.CHAT_RIGHT_SIDER_ENABLE]: boolean;
  [key: string]: boolean;
}

const clientConfig = {
  [ClientConfigEnum.JD_AUDIO]: true // 语音通话是否使用京东会议禁用voip
};

export function addConfig(part: Partial<ClientConfig>): void {
  Object.keys(part).forEach((prop) => {
    //@ts-ignore
    clientConfig[prop] = part[prop];
  });
}

export default clientConfig;
